var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomGoals = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.913 14.861 1.916-2.554a.692.692 0 0 0-.557-1.108h-3.713c-.22 0-.426.1-.557.275l-2.223 2.968a.686.686 0 0 0 0 .832l2.229 2.968a.694.694 0 0 0 .557.276h3.713a.692.692 0 0 0 .557-1.108l-1.922-2.549z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 14.166h1.604a5.25 5.25 0 0 0-5.197-4.551 5.253 5.253 0 0 0-5.246 5.246 5.253 5.253 0 0 0 5.246 5.247 5.25 5.25 0 0 0 5.197-4.552H16.51a3.667 3.667 0 0 1-3.594 2.968 3.663 3.663 0 0 1 0-7.325 3.667 3.667 0 0 1 3.594 2.967z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9 19.075-1.666-2.217a6.64 6.64 0 0 1-6.323 4.633 6.637 6.637 0 0 1-6.63-6.63 6.637 6.637 0 0 1 6.63-6.63 6.64 6.64 0 0 1 6.323 4.633l1.666-2.216c.119-.163.263-.3.42-.42a9.596 9.596 0 0 0-8.41-4.965c-5.302 0-9.597 4.302-9.597 9.598 0 5.297 4.295 9.598 9.598 9.598a9.596 9.596 0 0 0 8.408-4.965 2.049 2.049 0 0 1-.42-.42z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.91 14.166h2.167a2.282 2.282 0 0 0-2.166-1.584 2.28 2.28 0 0 0 0 4.558 2.274 2.274 0 0 0 2.166-1.584h-2.166a.697.697 0 0 1-.695-.695.697.697 0 0 1 .695-.695z",
    fill: "#9A5238"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomGoals);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-goals.62e495a2166ea569c349add11bf2d4a6.svg";